var selectedFlowType;
var selectedProductJson;
var selectedGiftProductJson;
var selectedGrindType;
var selectedFrequency;
var selectedPlanName;
var recipeintDetails;
var senderDetails;
var isBuildYourOwn=false;
var selectedBagAmount;
var selectedVariant;
var count=0;
var selectedOwnCoffeeProductsArr = [];
var selectedOwnItem;
var selectedBundle = [];
var selectedBagprice = [];
var selectedBagvariant;
var giftProductSkus = '';
var bundleProductSkus ='';



class subscriptionFunnel extends HTMLElement {
    constructor() {
      super();
      this.funnel=document.querySelector('subscription-funnel');
      this.domEvents();
      if(this.querySelector('.subscription-loading'))
      this.querySelector('.subscription-loading').classList.add('d-none');
      if( this.querySelector('[data-step="box-selection"]'))
      this.querySelector('[data-step="box-selection"]').classList.remove('d-none');
      this.checkMegamenuLink();
    }

    checkMegamenuLink(){

        let locationHandle = window.location.href.split('?');
        locationHandle = locationHandle[locationHandle.length-1];
        if(locationHandle.includes('id')){
           if(this.querySelector('.subscription-loading')) this.querySelector('.subscription-loading').classList.remove('d-none')
            if(this.querySelector('[data-step="box-selection"]')) this.querySelector('[data-step="box-selection"]').classList.add('d-none');
            const urlParams = new URLSearchParams(window.location.search);
            let productId = urlParams.get('id');
            let flowType = urlParams.get('flow');
            if( productId && flowType ){
                document.querySelector(`[data-flow="${flowType}"][data-selectedProduct="${productId}"]`).dispatchEvent(new Event('click'));
                selectedFlowType = flowType;
                this.querySelectorAll('[data-step]').forEach( steps => {
                    steps.classList.add("d-none");
                })
                this.displayStep(1);
            if(this.querySelector('.subscription-loading')) this.querySelector('.subscription-loading').classList.add('d-none');
                this.manageBreadCrumbs(1);
            }
        }
    }

    /**
     * Document eventlistners
     */
    domEvents(){
        this.grindSelection = this.querySelectorAll('[data-grindSelection]');
        this.grindSelection.forEach( btn => btn.addEventListener('click' , this.coffeeGrindTypeSelection.bind(this))); 

        this.coffeeSelection = this.querySelectorAll('[data-coffeeSelection]');
        this.coffeeSelection.forEach( btn => btn.addEventListener('click' , this.coffeeBoxSelection.bind(this)));

        this.frequencyselection = this.querySelectorAll('[data-frequencyselection]');
        this.frequencyselection.forEach( btn => btn.addEventListener('click' , this.chargefrequencyselection.bind(this)));

        this.bagSelection = this.querySelectorAll('[data-chooseBag]');
        this.bagSelection.forEach(btn => btn.addEventListener('click', this.coffeebagSelection.bind(this)));

        this.selectCoffeeProductEle = this.querySelectorAll('[data-selectCoffeeProduct]');
        this.selectCoffeeProductEle.forEach(btn => btn.addEventListener('click', this.selectCoffeeProducts.bind(this)));

        this.qtyBtns = this.querySelectorAll('[data-qty-btns]');
        this.qtyBtns.forEach( btn => btn.addEventListener('click', this.manageQty.bind(this)))

        this.buildBoxEle = this.querySelectorAll('[data-buildNext]');
        this.buildBoxEle.forEach( btn => btn.addEventListener('click' , this.gotoNextStep.bind(this)));
        
        this.coffeeBox = this.querySelectorAll('[data-gotoNext]');
        this.coffeeBox.forEach( btn => btn.addEventListener('click' , this.gotoNextStep.bind(this)));

        this.breadcrumbsLink = this.querySelectorAll('[data-nav_step]');
        this.breadcrumbsLink.forEach( navlink => navlink.addEventListener('click' , this.gotoPreviousStep.bind(this)));

        this.addtoCartEle = this.querySelectorAll('[data-addtocart]');
        this.addtoCartEle.forEach( btn => btn.addEventListener('click' , this.addProduct.bind(this)));

        this.giftFormInputs = this.querySelectorAll('[data-customer-addresses] input,[data-customer-addresses] select');
        this.giftFormInputs.forEach( input => input.addEventListener('change' , this.validateForm.bind(this)));

    }

    /**
     * select the coffee from your own 
     * @param {*} event 
     */
    selectCoffeeProducts(event){
        event.target.closest('[data-addBtns]').querySelector('[data-addedCoffeeProduct]').classList.remove('d-none');
        event.target.closest('[data-addBtns]').querySelector('[data-selectCoffeeProduct]').classList.add('d-none');
        this.querySelector('[data-stickyBar]').classList.remove('hide-stickyBar');
        this.querySelector('[data-stickyBar]').classList.add('show-stickyBar');
        let selectedProID = event.target.closest('[data-selectCoffeeProduct]').getAttribute('data-productId');
        let productJsonEle = this.querySelector(`[data-selectCoffeeProId="${selectedProID}"]`);
        let roastDetail = productJsonEle.closest('[data-product-grid]').querySelector('[data-roastType]').getAttribute('data-roastType')
        let productJson = productJsonEle.innerHTML;
        productJson = JSON.parse(productJson);
        this.manageSelection(productJson,roastDetail);
        this.querySelectorAll('[data-amount-emptybag]').forEach( ele => {
            ele.classList.add('d-none')
        })

        this.querySelectorAll(`[data-amount-emptybag="${selectedBagAmount}"]`).forEach( ele => {
            ele.classList.remove('d-none')
        })
        this.manageEmptyBagSvg();
    }

     /**
     * Manage the bottom
     *  @param {totalAmount} - total amount of a bag
     * @param {product} - Selected Product
     */
     manageSelection(product,roastDetail){
        let variantsArray = product.variants;
        this.setCoffeeVariant(variantsArray,'','');
            selectedOwnCoffeeProductsArr.push(product);
            selectedOwnItem = {
                proid: product.id,
                proTitle:product.title,
                varjson:selectedVariant,
                proImage:product.featured_image,
                quantity:1,
                roastType: roastDetail
            }
            selectedBundle.push(selectedOwnItem);
            this.manageEmptyBagSvg();
    }

    /**
     * Manage the quanity of the bag
     * @param {} event - click event
     */
    manageQty(event){
        event.preventDefault();
        let action = event.target.closest('[data-for]').getAttribute('data-for');
        let selectedProID = event.target.closest('[data-addbtns]').querySelector('[data-selectcoffeeproduct]').getAttribute('data-productId');
        selectedProID = parseInt(selectedProID);
        let currentBundleEle =  selectedBundle.find(x => selectedProID == x.proid);
        selectedOwnItem  = currentBundleEle
        action == 'decrease' ? selectedOwnItem.quantity = selectedOwnItem.quantity -1 : selectedOwnItem.quantity = selectedOwnItem.quantity + 1;
        if(action == 'decrease' && selectedOwnItem.quantity <=0 ){
            event.target.closest('[data-addBtns]').querySelector('[data-addedCoffeeProduct]').classList.add('d-none');
            event.target.closest('[data-addBtns]').querySelector('[data-selectCoffeeProduct]').classList.remove('d-none');
        }
        if(action == 'decrease' && selectedOwnItem.quantity == 0 ){
            selectedBundle.forEach( (ele,index) => {
                if( ele.quantity == 0){
                    selectedBundle.splice(index,1)
                }
            })
        }
        this.manageEmptyBagSvg();
    }

   /**
    * Display the empty bags depending upon bag size
    */
    manageEmptyBagSvg(){
        let totalBottomPro = 0 , addedProductEle;
        selectedBundle.forEach( ele=> {
            totalBottomPro = totalBottomPro + ele.quantity;
             addedProductEle =  this.querySelector(`[data-addedproductId="${ele.proid}"]`);
             addedProductEle.querySelector('[data-addedProductAmount]').innerHTML = `${ele.quantity}`;
        })
        let emptyBags = parseInt(selectedBagAmount) - totalBottomPro;
        let bagSize = parseInt(selectedBagAmount);
        this.querySelector('[data-selectionMobile]').innerHTML = `${totalBottomPro} of ${selectedBagAmount}`;

        for(let i=1;i<=bagSize;i++){
            let selectedProductCount = selectedBundle.length;
            if( i <= selectedProductCount ){
                this.querySelector(`[data-amount-emptybag="${selectedBagAmount}"][data-bag-index="${i}"] [data-selectedProductSVG]`).classList.remove('d-none');
                this.querySelector(`[data-amount-emptybag="${selectedBagAmount}"][data-bag-index="${i}"] [data-emptyBagSVG]`).classList.add('d-none');
                this.querySelector(`[data-amount-emptybag="${selectedBagAmount}"][data-bag-index="${i}"] [data-selectedProductSVG] [data-selectedProCount]`).innerHTML = selectedBundle[i-1].quantity;
                this.querySelector(`[data-amount-emptybag="${selectedBagAmount}"][data-bag-index="${i}"] [data-selectedProductSVG] img`).setAttribute('src',selectedBundle[i-1]['proImage'])
            }
            else if( i > selectedProductCount && (selectedBagAmount-i) > emptyBags ){
                this.querySelector(`[data-amount-emptybag="${selectedBagAmount}"][data-bag-index="${i}"]`).classList.add('d-none');
            }
            else if( i == totalBottomPro ){
                this.querySelector(`[data-amount-emptybag="${selectedBagAmount}"][data-bag-index="${i}"]`).classList.add('d-none');
            }
            else{
                this.querySelector(`[data-amount-emptybag="${selectedBagAmount}"][data-bag-index="${i}"]`).classList.remove('d-none');
                this.querySelector(`[data-amount-emptybag="${selectedBagAmount}"][data-bag-index="${i}"] [data-emptyBagSVG]`).classList.remove('d-none');
                this.querySelector(`[data-amount-emptybag="${selectedBagAmount}"][data-bag-index="${i}"] [data-selectedProductSVG]`).classList.add('d-none');
            }

        }
        
        if(totalBottomPro >= parseInt(selectedBagAmount)){
            this.querySelector('[data-continuetoadd]').classList.remove('disable');
            this.querySelectorAll('[data-selectcoffeeproduct]').forEach( ele => {
                ele.classList.add('disable')
            })
            this.querySelectorAll('[data-btnincrease]').forEach( ele => {
                ele.classList.add('disable');
            })
        }
        else{
            this.querySelector('[data-continuetoadd]').classList.add('disable');
            this.querySelectorAll('[data-selectcoffeeproduct]').forEach( ele => {
                ele.classList.remove('disable')
            })
            this.querySelectorAll('[data-btnincrease]').forEach( ele => {
                ele.classList.remove('disable');
            })
        }
    }

   

    /**
     * Clear the selected products on the previous step
     * 
     */
    clearSelectedProducts(){
        // this.querySelectorAll('[data-amount-emptybag]').forEach( ele => {
        //     ele.classList.add('d-none')
        // })
        selectedBundle =[];
        selectedOwnItem = {};
        this.querySelectorAll('[data-addedCoffeeProduct]').forEach( ele => {
            ele.classList.add('d-none')
        })
        this.querySelectorAll('[data-selectCoffeeProduct]').forEach( ele => {
            ele.classList.remove('d-none')
        })
    }


    /**
     * Coffee bag selection of build your own flow 
     * how many bags to send
     * @param {*} event 
     */
    coffeebagSelection(event){
        let options = [];
        let amount = event.target.closest('[data-bagAmount]').getAttribute('data-bagAmount');
        options.push(amount)
        selectedBagAmount = amount;
        this.querySelectorAll('[data-bagAmount]').forEach( ele => {
            ele.classList.remove('selected')
        })
        this.querySelector(`[data-bagAmount="${amount}"]`).classList.add('selected');
        let variantsArray;

        selectedFlowType == 'send-gift' ?  variantsArray = selectedGiftProductJson.variants :  variantsArray = selectedProductJson.variants;

        variantsArray.find((variant) => {
            let mappedValues = variant.options.map((option, index) => {
                return options[index] === option.toLowerCase();
              });
             if(!mappedValues.includes(false)){
                selectedBagvariant = variant
             }
        })

    }


    /**
     * Validate the form - before checkout
     */
    validateForm(event){
       let formEle = event.target.closest('form');
       let fields = [];
       let giftMsg='';
       let recipientFname = formEle.querySelector('[data-recipientFname]').value;
       let recipientLname = formEle.querySelector('[data-recipientLname]').value;
       let recipientEmail = formEle.querySelector('[data-recipientEmail]').value;
          let senderFirstname = formEle.querySelector('[data-firstname]').value;
       let senderLastname = formEle.querySelector('[data-lastname]').value;
       
       if(formEle.querySelector('[data-recipientMsg]').value != '')
         giftMsg = formEle.querySelector('[data-recipientMsg]').value;
       
        recipeintDetails = {
            fname: recipientFname,
            lname: recipientLname,
            email: recipientEmail,
            giftMsg: giftMsg
        }
       senderDetails = {
            fname:senderFirstname,
            lname:senderLastname
        }

        senderDetails = {
            fname:senderFirstname,
            lname:senderLastname
        }

        let allFormInputs = formEle.querySelectorAll('[data-customer-addresses] input[data-required],[data-customer-addresses] select[data-required]');
        allFormInputs.forEach( ele => {
            let length = ele.value.length;
            length>0 ? fields.push(true) : fields.push(false);
        })
     
        if(!fields.includes(false)){
         
            this.querySelectorAll('[data-addtocart]').forEach( ele => {
                ele.classList.remove('disable') 
            })
        }
        else{
            this.querySelectorAll('[data-addtocart]').forEach( ele => {
                ele.classList.add('disable') 
            })
        }
        
    }

    /**
     * store the build your own box gift products
     */
    buiildBoxGiftProducts(){
      let giftProJSON;
      let giftProductsArray = [];
      let giftProduct;
      let giftProductEle = this.querySelector(`[data-Gifts="${selectedBagAmount}"]`);
      giftProductEle.querySelectorAll('[data-buildgiftproducts]').forEach( ele => {
         giftProJSON = JSON.parse(ele.innerHTML);
         let variantsArray = giftProJSON.variants
         this.setCoffeeVariant(variantsArray,'','');

         let quanity = 1;
         giftProductSkus += (giftProductSkus.length ? ',' :'') + `${selectedVariant.sku}___${quanity}`;
         giftProduct = {
            proId : giftProJSON.id,
            proTitle : giftProJSON.title,
            varID: selectedVariant.id,
            varSku:selectedVariant.sku,
            quantity:1,
            roastType:'medium',
            variantImage: giftProJSON.featured_image
         }

         if (selectedVariant.featured_image && selectedVariant.featured_image.src) {
            giftProduct.variantImage = selectedVariant.featured_image.src;
         }

         giftProductsArray.push(giftProduct);
      })
      return giftProductsArray;
    }


    /**
     * Build Your own - selected products item array
     */
    _buildProducts(){
        let bundleProuct;
        let bundleProductArray = [];
        selectedBundle.forEach( ele => {
            bundleProductSkus += (bundleProductSkus.length ? ',' :'') + `${ele.varjson['sku']}___${ele.quantity}`;
            bundleProuct = {
                proId: ele.proid,
                proTitle: ele.proTitle,
                varID: ele.varjson['id'],
                quantity: ele.quantity,
                varSku:ele.varjson['sku'],
                roastType: ele.roastType,
                variantImage: ele.varjson['featured_image'] ?  ele.varjson['featured_image'].src : ele.proImage
            }
            bundleProductArray.push(bundleProuct)
        })
        return bundleProductArray;
    }


    /**
     * Add the selected Product to the cart
     */
    addProduct(event){
        let addItems=[];
        let giftProducts;
        var itemJson={} ;

        event.currentTarget.classList.add('disable');

        isBuildYourOwn && selectedFlowType == 'send-gift' ? giftProducts =  this.buiildBoxGiftProducts() : '' ; 
        isBuildYourOwn && selectedFlowType == 'subscribe' ? giftProducts = this._buildProducts() : '';
        if(isBuildYourOwn){
            if(selectedFlowType == 'send-gift'){
                selectedVariant = selectedBagvariant;
                let varID = selectedVariant.id
                let sellingID = selectedVariant.selling_plan_allocations[0].selling_plan_id
                let price = parseInt(selectedBagprice)*100;
                 itemJson = {
                id: varID,
                quantity:1,
                selling_plan:sellingID,
                price:price,
                properties:{
                    '_coffeeType': selectedGrindType,
                    '_BYOProducts': giftProducts,
                    '_BYOSkus':giftProductSkus,
                    '_isGiftEditable': true,
                }
            };
            addItems.push(itemJson)
            }
            else{
                selectedVariant = selectedBagvariant;
                let varID = selectedVariant.id
                let sellingID = selectedVariant.selling_plan_allocations[0].selling_plan_id;
                let price = selectedBagprice
                itemJson = {
                    id:varID,
                    quantity:1,
                    selling_plan:sellingID,
                    price: price,
                    properties:{
                        '_coffeeType': selectedGrindType,
                        '_BYOProducts': giftProducts,
                        '_BYOSkus': bundleProductSkus
                    }
                }
                addItems.push(itemJson)
            }
        }   
        else{
            let varID = selectedVariant.id
            let sellingID = selectedVariant.selling_plan_allocations[0].selling_plan_id;
             itemJson = {
                id: varID,
                quantity:1,
                selling_plan:sellingID,
                properties:{
                    '_coffeeType': selectedGrindType
                }
            };
            addItems.push(itemJson)
        }

        if(selectedFlowType == 'send-gift'){
            itemJson.properties['_chargeFrequency'] = selectedFrequency;
            itemJson.properties['_recipientName'] = `${recipeintDetails.fname} ${recipeintDetails.lname}`;
            itemJson.properties['_recipientEmail'] = recipeintDetails.email;
            itemJson.properties['_recipientMsg'] = recipeintDetails.giftMsg;
            itemJson.properties['_isGift'] = true;
            itemJson.properties['_isGiftEditable']= true
           itemJson.properties['_senderFullName'] = `${senderDetails.fname} ${senderDetails.lname}`;
        }

        itemJson.properties['_productType'] = 'subscription-flow';
        itemJson.properties['_isSubscriptionBox'] = true;
        const body = JSON.stringify({
            items: addItems,
          });
          fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
            .then((response) => response.json())
            .then((data) => {
                window.location.href='/checkout';
            })
            .catch((e) => {
              console.error(e);
            })
    }

    /**
     * Charge frequency selection
     */
    chargefrequencyselection(event){
        let frequency = event.target.closest('[data-frequencyselection]').getAttribute('data-frequencyselection')
        selectedFrequency = frequency;
        this.querySelectorAll('[data-frequencyselection]').forEach( ele => {
            ele.classList.remove('selected')
        })
        this.querySelector(`[data-frequencyselection="${selectedFrequency}"]`).classList.add('selected');
    }

    /**
     * Select a grind type
     * stroing a value for the grindtype
     * @param { event}  
     */
    coffeeGrindTypeSelection(event){
        let GrindType = event.target.closest('[data-selectedGrind]').getAttribute('data-selectedGrind');
        let jofferyVariant = event.target.closest('[data-selectedGrind]').getAttribute('data-joffery');
        let disneyVariant = event.target.closest('[data-selectedGrind]').getAttribute('data-disney');
        selectedGrindType = GrindType;
        this.querySelectorAll('[data-selectedGrind]').forEach( ele => {
            ele.classList.remove('selected')
        })

        let variantsArray;
        selectedFlowType == 'send-gift' ?  variantsArray = selectedGiftProductJson.variants :  variantsArray = selectedProductJson.variants;
        isBuildYourOwn ? '' : this.setCoffeeVariant(variantsArray,jofferyVariant,disneyVariant);
        this.querySelector(`[data-selectedGrind="${selectedGrindType}"]`).classList.add('selected');

       
    }


    /**
     * Coffee variant selection
     * @param {*} grindtype - selected grindtype to map with the product variants
     */
    setCoffeeVariant(variantsArray, jofferyVariant, disneyVariant){
        if(selectedProductJson.title == 'JOFFREY’S CHOICE'){
            const d = new Date();
            let monthNumber = d.getMonth() + 1;
            let monthName = d.toLocaleString('en-US', { month: 'long' });
            let optionName = `${jofferyVariant}-${monthName}-${monthNumber}`
            selectedVariant = variantsArray.find(variant => variant.title === optionName.toUpperCase());
            
        } else if(selectedProductJson.title == 'DISNEY COFFEE COLLECTION' || selectedProductJson.title == 'DISNEY COFFEE COLLECTION 2025'){
            const d = new Date();
            let monthNumber = d.getMonth() + 1;
            let monthName = d.toLocaleString('en-US', { month: 'long' });
            let optionName = `${disneyVariant}-${monthName}-${monthNumber}`
            selectedVariant = variantsArray.find(variant => variant.title === optionName.toUpperCase());
        } else {
            let options = this._getOptions();
            variantsArray.find((variant) => {
                let mappedValues = variant.options.map((option, index) => {
                    return options[index] === option.toLowerCase();
                  });
                 if(!mappedValues.includes(false)){
                    selectedVariant = variant
                 }
            })
        }
        
    }

/**
 * Get the options from the flow
 * @returns - { option } - selected option 
 */
    _getOptions(){
        let options = [];
        isBuildYourOwn && selectedFlowType == 'send-gift' ? options.push('ground') : options.push(selectedGrindType);
        return options;
    }

    /**
     * Coffee box selection
     * storing a product JSON
     * @param { event }  
     */
    coffeeBoxSelection(event){
        let subscriptionMenu;
        event.target.closest('[data-subscriptionMegamenu]') ? subscriptionMenu = true : subscriptionMenu = false;
        // event.preventDefault();
        let proId = event.target.getAttribute('data-selectedProduct');
        let productJsonEle = event.target.closest('subscription-funnel').querySelector(`[data-proId="${proId}"]`);
        let giftProductEle = event.target.closest('subscription-funnel').querySelector(`[data-proId="${proId}"]`);

        let productJson = productJsonEle.innerHTML;
        let giftJson = giftProductEle.innerHTML;

        productJson = JSON.parse(productJson)
        giftJson = JSON.parse(giftJson)

        selectedProductJson = productJson;
        selectedGiftProductJson = giftJson;

        let planName = event.target.closest('[data-plantitle]').getAttribute('data-plantitle');
        selectedPlanName = planName;
        if(subscriptionMenu){
            // window.location.href = "/pages/build-box";
            let subscriptionboxval = event.target.closest('[data-subscriptionMegamenu]').getAttribute('data-index');
            // document.querySelector(`[data-subscriptionChoice-${subscriptionboxval}]`).dispatchEvent(new Event('click'));
         }
    }

    /**
     * Display the order summary
     * 
     */
    _displayOrderSUmmary(){
        this.clearAllformInputs();
        selectedProductJson.handle == 'joffrey-s-choice' ? document.querySelector('[data-reviewJoffreyimg]').classList.remove('d-none') : document.querySelector('[data-reviewJoffreyimg]').classList.add('d-none');
        selectedProductJson.handle == 'disney-coffee-collection' ? document.querySelector('[data-reviewDisneyimg]').classList.remove('d-none') : document.querySelector('[data-reviewDisneyimg]').classList.add('d-none') ;
      
        if(selectedFlowType == 'send-gift'){
            this.querySelector('[data-addtocart]').classList.add('disable');
            this.querySelector('[data-isGiftForm]').classList.remove('d-none');
            this.querySelector('[data-reviewGiftShape]').classList.remove('d-none');
            this.querySelector('[data-reviewNormalShape]').classList.add('d-none');
        }
        else{
            this.querySelector('[data-addtocart]').classList.remove('disable');
            this.querySelector('[data-isGiftForm]').classList.add('d-none');
            this.querySelector('[data-reviewGiftShape]').classList.add('d-none');
            this.querySelector('[data-reviewNormalShape]').classList.remove('d-none');
        }


        this.querySelectorAll('[data-reviewRegularsubheading] , [data-reviewGiftsubheading] , [data-totalShippingInfoRegular],[data-totalShippingInfoGift]').forEach( ele => {
            ele.classList.add('d-none')
        })

         if(selectedFlowType == 'send-gift'){
            this.querySelectorAll('[data-reviewGiftsubheading] , [data-totalShippingInfoGift]').forEach(ele => {
                ele.classList.remove('d-none')
            })
         }
         else{
            this.querySelectorAll('[data-reviewRegularsubheading],[data-totalShippingInfoRegular]').forEach(ele => {
                ele.classList.remove('d-none')
            })
         }

        if(isBuildYourOwn){
            this.querySelector('[data-step="subscriptionReview"] [data-buildboxreview]').classList.remove('d-none');
            this.querySelector('[data-step="subscriptionReview"] [data-defaultChoicereview]').classList.add('d-none');
            if(selectedFlowType == 'send-gift'){
                this.querySelector('[data-buildboxreview] .summary_header h4').innerHTML = 'Your Gift Subscription';
                this.querySelector('[data-buildboxreview] [data-orderTypes]').innerHTML = `
                <div class="bag-size">
                <p class="mb-0 text-uppercase text-primary fw-bold font-size-14 ls-sm mt-lg-3 mt-2">Size:</p>
                <p class="mb-0" data-bagSize>${selectedBagAmount} bags</p>
            </div>
            <div class="length">
                <p class="mb-0 text-uppercase text-primary fw-bold font-size-14 ls-sm mt-lg-3 mt-3">length:</p>
                <p class="mb-0" data-length>${selectedFrequency}</p>
                <p class="mb-0"> Billed & shipped monthly</p>
            </div>
                `
              this.querySelector('[data-buildboxreview] [data-selectedCoffeeRview]').innerHTML= `<p class="mb-0">The gift recipient will choose their grind and coffee selections within their account dashboard when they set up their subscription.</p>`
            }
            else{
                this.querySelector('[data-buildboxreview] .summary_header h4').innerHTML = 'Your Subscription' ;
                this.querySelector('[data-buildboxreview] [data-orderTypes]').innerHTML = `
                <div class="bag-size">
                <p class="mb-0 text-uppercase text-primary fw-bold font-size-14 ls-sm mt-lg-3 mt-2">Size:</p>
                <p class="mb-0" data-bagSize>${selectedBagAmount} bags</p>
                </div>
                <div class="grind-type">
                <p class="mb-0 text-uppercase text-primary fw-bold font-size-14 ls-sm mt-lg-3 mt-3">grind:</p>
                <p class="mb-0 text-capitalize" data-grindType>${selectedGrindType}</p>
                </div>
                <div class="length">
                <p class="mb-0 text-uppercase text-primary fw-bold font-size-14 ls-sm mt-lg-3 mt-3">Frequency:</p>
                <p class="mb-0 d-none d-lg-block" data-frequency>Monthly</p>
                <p class="mb-0 d-none d-lg-block"> Skip or cancel anytime!</p>
                <p class="mb-0  d-lg-none" data-frequency>Monthly, Skip or cancel anytime!</p>
                </div>
                `
                this.displaySelectedCoffeeProducts();
            }
          
            let orderPrice = selectedBagvariant.price;
            let orderComparePrice = selectedBagvariant.compare_at_price;
          
            orderPrice = Shopify.formatMoney(orderPrice, window.globalVariables.money_format);

            this.querySelector('[data-orderPrice]').innerHTML = orderPrice;
            if(orderComparePrice > 0){
                orderComparePrice = Shopify.formatMoney(orderComparePrice, window.globalVariables.money_format);

                this.querySelector('[data-compare-price]').innerHTML = orderComparePrice;

            }

            
        }
        else{


            if(selectedFlowType == 'send-gift'){
                this.querySelector('[data-defaultChoicereview] .summary_header h4').innerHTML = 'Your Gift Subscription';
                this.querySelector('[data-defaultChoicereview] [data-orderTypes]').innerHTML = `
                <div class="grind-type">
                <p class="mb-0 text-uppercase text-primary fw-bold font-size-14 ls-sm mt-lg-3 mt-2">grind:</p>
                <p class="mb-0 text-capitalize" data-grindType>${selectedGrindType}</p>
            </div>
            <div class="length">
                <p class="mb-0 text-uppercase text-primary fw-bold font-size-14 ls-sm mt-lg-3 mt-3">length:</p>
                <p class="mb-0" data-length>${selectedFrequency}</p>
                <p class="mb-0"> Billed & shipped monthly</p>
            </div>
                `
            }
            else{
                this.querySelector('[data-defaultChoicereview] .summary_header h4').innerHTML = 'Your Subscription'
                this.querySelector('[data-defaultChoicereview] [data-orderTypes]').innerHTML = `
                
                <div class="grind-type">
                <p class="mb-0 text-uppercase text-primary fw-bold font-size-14 ls-sm mt-lg-3 mt-2">grind:</p>
                <p class="mb-0 text-capitalize" data-grindType>${selectedGrindType}</p>
            </div>
            <div class="frequency">
                <p class="mb-0 text-uppercase text-primary fw-bold font-size-14 ls-sm mt-lg-3 mt-3">frequency:</p>
                <p class="mb-0 d-none d-lg-block" data-frequency>Monthly</p>
                <p class="mb-0 d-none d-lg-block"> Skip or cancel anytime!</p>
                <p class="mb-0  d-lg-none" data-frequency>Monthly, Skip or cancel anytime!</p>
            </div>
                `
            }
            this.querySelector('[data-step="subscriptionReview"] [data-buildboxreview]').classList.add('d-none');
            this.querySelector('[data-step="subscriptionReview"] [data-defaultChoicereview]').classList.remove('d-none');
            selectedPlanName ? this.querySelector('[data-orderSummaryTitle]').innerHTML = selectedPlanName : this.querySelector('[data-orderSummaryTitle]').innerHTML = 'Build Your Own' ;
            let orderPrice = selectedProductJson.variants[0].price;
            let orderComparePrice = selectedProductJson.variants[0].compare_at_price;
            orderPrice = Shopify.formatMoney(orderPrice, window.globalVariables.money_format);
            this.querySelector('[data-orderPrice]').innerHTML = orderPrice;
            if(orderComparePrice > 0){
                orderComparePrice = Shopify.formatMoney(orderComparePrice, window.globalVariables.money_format);

                this.querySelector('[data-compare-price]').innerHTML = orderComparePrice;
            }

        }
        
    }

    /**
     * Build Your own flow - display selected coffee products s 
     */
    displaySelectedCoffeeProducts(){
        let productHtml = '';
        selectedBundle.forEach( product => {
            productHtml += `<div class="col-12 col-lg-6">
            <div class="d-flex border-primary-200 border selected_product position-relative">
                <div class="pro_image">
                    <img src="${product.proImage}" loading="lazy" width="80" height="105" />
                </div>
                <div class="pro_details ps-4 pt-1">
                    <h6 class="font-base">${product.proTitle}</h6>
                    <p class="font-size-sm fw-semibold text-uppercase ls-25">${product.roastType} roast</p>
                </div>
                <div class="selected_product_count position-absolute">
                    ${product.quantity}
                </div>
            </div>
        </div>`
    })
    this.querySelector('[data-selectedCoffeeRview]').innerHTML = productHtml;
    }

    /**
     * On previous step clear all input fields
     */
    clearAllformInputs(){
        this.querySelectorAll('[data-customer-addresses] input').forEach( ele => {
            ele.value = '' ;
        })
    }


    /**
     * Go to next step based on the flow type steps
     * @param {event} - event 
     * 
     */
    gotoNextStep(event){
        event.preventDefault();
        window.scrollTo(0, 0);
        document.querySelector('body').scrollTop = 0;
        document.body.scrollTop;

        document.querySelector('body').scrollTo({
            top:0,
            left:0,
            behavior: "smooth",
          });


        let flowType = event.target.getAttribute('data-flow');
        let BuildYourOwn = event.target.getAttribute('data-buildYourOwn');

        if(BuildYourOwn)
         BuildYourOwn == 'yes' ? isBuildYourOwn = true : isBuildYourOwn=false;
         if(flowType){
            selectedFlowType = flowType;
            if(selectedFlowType == 'send-gift'){
                this.querySelector('[data-giftbagInfo]').classList.remove('d-none');
                this.querySelector('.coffee-type-wrapper').classList.add('gift-coffee');
                this.querySelector('.bag-frequency').classList.add('gift-bag'); 
                this.querySelector('[data-ordersummary]').classList.add('gift-ordersummary');
                this.querySelector('.choose-grind').classList.add('.gift-grind');
            }
            else{
                this.querySelector('[data-giftbagInfo]').classList.add('d-none');
                this.querySelector('.coffee-type-wrapper').classList.remove('gift-coffee');
                this.querySelector('.bag-frequency').classList.remove('gift-bag');
                this.querySelector('[data-ordersummary]').classList.remove('gift-ordersummary');
                this.querySelector('.choose-grind').classList.remove('.gift-grind');
            }
         }

        let flowStep  = this._nextFlowstep(event);
        this.displayStep(flowStep);
        this.manageBreadCrumbs(flowStep);
    }





    // GENERAL METHODS
    /**
     * 
     * @param {*} event 
     * @returns Next flow step to display 
     */
    _nextFlowstep(event){ 
        if(isBuildYourOwn)
        return event.target.closest(`[data-buildOwn-${selectedFlowType}]`).getAttribute(`data-buildOwn-${selectedFlowType}`);

        else
        return event.target.closest(`[data-${selectedFlowType}]`).getAttribute(`data-${selectedFlowType}`);
    }


    /**
     * Next flow step for the build ypur own box
     * @param {*} event 
     */
    _nextBuildFlowstep(event){
        return event.target.closest(`[data-buildOwn-${selectedFlowType}]`).getAttribute(`data-buildOwn-${selectedFlowType}`)
    }

    /**
     * Display the next step
     * @param {nextStep} - nextstep selector
     */
    displayStep(nextStep){
        window.scrollTo(0, 0);
        document.querySelector('body').scrollTop = 0;
        nextStep = parseInt(nextStep)+1;
        nextStep > 1 ? document.querySelector('.dynamic-faq-block').classList.add('d-none') : document.querySelector('.dynamic-faq-block').classList.remove('d-none')

        this.querySelectorAll('[data-step]').forEach( steps => {
            steps.classList.add("d-none");
        })
    
        if(selectedFlowType){
            if(selectedFlowType == 'send-gift'){
                this.querySelector('[data-giftGrindSubtext]')?.classList.add('d-none');
                this.querySelector('[data-giftGrindInfo]')?.classList.remove('d-none');
                this.querySelector('[data-grindgiftshape]')?.classList.remove('d-none');
                this.querySelector('[data-grindshape]')?.classList.add('d-none');
            }
            else{
                this.querySelector('[data-giftGrindSubtext]')?.classList.remove('d-none');
                this.querySelector('[data-giftGrindInfo]')?.classList.add('d-none');
                this.querySelector('[data-grindgiftshape]')?.classList.add('d-none');
                this.querySelector('[data-grindshape]')?.classList.remove('d-none');
            }
        }
        

         isBuildYourOwn ? this.querySelector(`[data-buildOwn-${selectedFlowType}="${nextStep}"]`).classList.remove('d-none') : this.querySelector(`[data-${selectedFlowType}="${nextStep}"]`)?.classList.remove('d-none');
         let isreviewStep = this.querySelector('[data-step="subscriptionReview"]')?.classList.contains('d-none');
         isreviewStep == false ? this._displayOrderSUmmary() : '';
    }

    /**
     * Manage the breadcrumbs
     */
    manageBreadCrumbs(activeStep){
        let isStep1 =  this.querySelector('[data-step="box-selection"]')?.classList.contains('d-none');
         
        if(isBuildYourOwn){
              this.querySelectorAll(`[data-breadcrumbs="${selectedFlowType}-buildown"] [data-nav_step]`).forEach(ele => {
                let step=parseInt(ele.getAttribute('data-nav_step'))
                activeStep=parseInt(activeStep);
                activeStep+1 >= step ? ele.classList.remove('disable') : ele.classList.add('disable')
              })
          }
          else{
            this.querySelectorAll(`[data-breadcrumbs="${selectedFlowType}"] [data-nav_step]`).forEach(ele => {
                let step=parseInt(ele.getAttribute('data-nav_step'))
                activeStep=parseInt(activeStep);
                activeStep+1 >= step ? ele.classList.remove('disable') : ele.classList.add('disable')
              })
          }
       
          isBuildYourOwn ? this.querySelector(`[data-breadcrumbs="${selectedFlowType}-buildown"]`)?.classList.remove('d-none') : this.querySelector(`[data-breadcrumbs="${selectedFlowType}"]`)?.classList.remove('d-none');
          
            if(!isStep1){
                this.querySelectorAll('[subscription-breadcrumbs]').forEach( element => {
                    element.classList.add('d-none');
             })
        }
    }

    /**
     * go to the previous step with breadcrumbs
     * @param {*} event 
     */
    gotoPreviousStep(event){
        count=0;
        selectedBundle=[];
        selectedOwnCoffeeProductsArr = [];
        isBuildYourOwn && !selectedFlowType!= 'send-gift' ? this.clearSelectedProducts() : '';

        selectedFlowType == 'send-gift' ? this.clearAllformInputs():'';

        let stepTodisplay = parseInt(event.target.closest('[data-nav_step]').getAttribute('data-nav_step'));

        if(stepTodisplay == 1){
            this.querySelectorAll('[data-selectedGrind]').forEach( ele => {
                ele.classList.remove('selected')
            })
            this.querySelectorAll('[data-frequencyselection]').forEach( ele => {
                ele.classList.remove('selected')
            })
        }

        stepTodisplay > 1 ? document.querySelector('.dynamic-faq-block').classList.add('d-none') : document.querySelector('.dynamic-faq-block').classList.remove('d-none')
        this.querySelectorAll('[data-step]').forEach( steps => {
            steps.classList.add("d-none");
        })
        isBuildYourOwn ? this.querySelector(`[data-buildown-${selectedFlowType}="${stepTodisplay}"]`).classList.remove('d-none') : this.querySelector(`[data-${selectedFlowType}="${stepTodisplay}"]`).classList.remove('d-none');
        this.manageBreadCrumbs(stepTodisplay-1);
        this.querySelector('[data-stickyBar]').classList.add('hide-stickyBar');
        this.querySelector('[data-stickyBar]').classList.remove('show-stickyBar');

        this.clearSelectedProducts();
        this.querySelectorAll('[data-selectcoffeeproduct]').forEach( ele => {
            ele.classList.remove('disable')
        })

        
    }

}
customElements.define("subscription-funnel", subscriptionFunnel);


